import { __exportAll } from "../_virtual/_rolldown/runtime.js";
import { OrderChannel } from "@biteinc/enums";
import { systemIsKioskPayment } from "@biteinc/common";
//#region src/helpers/base_location_helper.ts
var base_location_helper_exports = /* @__PURE__ */ __exportAll({
	getOrderChannel: () => getOrderChannel,
	isPrinterFailureBlocker: () => isPrinterFailureBlocker
});
function getOrderChannel(locationOrderChannel, isFlashUser) {
	switch (locationOrderChannel) {
		case OrderChannel.DriveThru: return OrderChannel.DriveThru;
		case OrderChannel.Flash:
		case OrderChannel.Kiosk: return isFlashUser ? OrderChannel.Flash : OrderChannel.Kiosk;
		case OrderChannel.Linebuster: return OrderChannel.Linebuster;
		case OrderChannel.Web: return OrderChannel.Web;
	}
}
function isPrinterFailureBlocker(settings, locationSettings) {
	const hasPaymentIntegration = Object.values(locationSettings.integrationById).some(({ system }) => systemIsKioskPayment(system));
	return (settings.orderedItemPlusQrCodeConfig || settings.printOrderNumberBarcode) && !hasPaymentIntegration || settings.showMaintenanceScreenIfPrinterIsNotWorking;
}
//#endregion
export { base_location_helper_exports, getOrderChannel, isPrinterFailureBlocker };

//# sourceMappingURL=base_location_helper.js.map